import React from 'react'
import { Grid, TextField, Typography } from '@mui/material'

const RiskMitigationField = ({
  value,
  handleChange,
  name,
  label,
  helperText,
}) => (
  <Grid item xs={12} lg={6}>
    <TextField
      value={value}
      onChange={handleChange}
      name={name}
      label={label}
      fullWidth
      autoComplete="off"
      helperText={helperText}
      InputLabelProps={{
        // shrink: !!event?.riskAssessment?.highRiskActivities
        shrink: true,
      }}
      multiline
      minRows={2}
    />
  </Grid>
)

const mitigations = [
  { name: 'mitigateStaff', label: 'Workforce' },
  { name: 'mitigateCommsFailure', label: 'Communications Failure' },
  { name: 'mitigateMajorIncidents', label: 'Major Incidents' },
  { name: 'mitigateTerroristAttack', label: 'Terrorist Attack' },
  { name: 'mitigateVehicleFailure', label: 'Vehicle Failure' },
  {
    name: 'mitigateMedicalGuidelines',
    label: 'Medical Guidelines',
    helperText:
      'Have any guidelines been used for this risk assessment? I.e. Purple Guide.',
  },
]

const methodStatements = [
  { name: 'methodPreEventPrep', label: 'Pre-Event Preparation' },
  { name: 'methodStaffingTraining', label: 'Staffing and Training' },
  { name: 'methodFacilities', label: 'Medical Facilities & Equipment' },
  { name: 'methodMedications', label: 'Medications' },
  { name: 'methodCommunications', label: 'Communications' },
  { name: 'methodNHSImpact', label: 'NHS Impact' },
  { name: 'methodPartnerWorking', label: 'Partnership Working' },
  { name: 'methodEscalatingConcerns', label: 'Escalating Concerns' },
  { name: 'methodConfidentiality', label: 'Patient Confidentiality' },
  { name: 'methodPostEventAnalysis', label: 'Post Event Analysis' },
  { name: 'methodFeedback', label: 'Event Provider Feedback' },
]
const RisksMitigations = ({ riskAssessment, handleChange }) => {
  return (
    <Grid item xs={12} container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="title3">Risks & Mitigations</Typography>
      </Grid>
      {mitigations.map((x) => (
        <RiskMitigationField
          key={x.name}
          value={riskAssessment?.[x.name]}
          handleChange={handleChange}
          name={x.name}
          label={x.label}
          helperText={x.helperText}
          InputLabelProps={{
            shrink: !!riskAssessment?.[x.name],
          }}
        />
      ))}
      <Grid item xs={12}>
        <Typography variant="title3">Method Statements</Typography>
      </Grid>
      {methodStatements.map((x) => (
        <RiskMitigationField
          key={x.name}
          value={riskAssessment?.[x.name]}
          handleChange={handleChange}
          name={x.name}
          label={x.label}
          helperText={x.helperText}
          InputLabelProps={{
            shrink: !!riskAssessment?.[x.name],
          }}
        />
      ))}
    </Grid>
  )
}

export default React.memo(RisksMitigations)
